import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { construction } from "../../../assets/imgs";
import moment from "moment";
import useStore from "../Zustand/useStore";
import SelectBox from "../../../components/SelectBox";
import StatusComp from "../../../components/StatusComp";
import { formatKey } from "../../redux/api/Constants";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";

const OverallAlertdetails = () => {
  const location = useLocation();
  const { type, data } = location.state;

  console.log("typeAlert", type);

  const navigate = useNavigate();

  const user = useStore((state) => state.user);
  const assignedTo = useStore((state) => state.assigned);
  const messageTo = useStore((state) => state.message);
  const givenuser = JSON.parse(localStorage.getItem("user_details"));

  const { setAssigned, setMessage } = useStore();

  const [showPopup, setShowPopup] = useState(false);

  const alertDetails_arr = {
    Company: "Sim Lian Construction Co (Pte) Ltd",
    SiteName: "Tampines",
    SiteCode: "TMZ-St62",
    Type: "Violation of PPE",
    ViolationType: "No_Harness",
    Camera: "C09 TC1 Camera 02",
    SeverityLevel: "1",
    CapturedAt: "2025-09-12 16:38:48",
    ReceivedAt: "2025-09-12 16:38:52",
    Group2EscalatedAt: "2025-09-12 16:54:03",
    Group3EscalatedAt: "2025-09-12 18:55:03",
  };

  const classifiedData_arr = {
    Classified: "",
    ClassifiedBy: "",
    ClassifiedAT: "",
    AssignedTo: "",
    ActAt: "",
  };

  const reassignedData_arr = {
    Re_AssignedTo: "-",
    Re_AssignedAt: "-",
    Re_AssignedMessage: "-",
    ClosedAt: "-",
    ClosedMessage: "-",
  };

  const [alertDetails, setAlertDetails] = useState({});
  const [classifiedData, setClassifiedData] = useState({});
  const [reassignedData, setReassignedData] = useState([]);
  const [reOpnedData, setReOpnedData] = useState([]);

  const [list, setList] = useState([]);

  const [details, setdetails] = useState({
    role: "",
    message: "",
    reOpen: "",
    reason: "",
    reassign: "",
    reassignMessage: "",
  });

  const [err, setErr] = useState({});
  const [show, setShow] = useState(false);
  const [shows, setShows] = useState(false);
  const [option, setOption] = useState(null);
  const [newList, setNewList] = useState({});
  // console.log("newList", newList);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setdetails((prev) => ({ ...prev, [name]: value }));
    setErr((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let newErrors = {};

    if (details.role == 4) {
      if (!option?.label) {
        // toast.error("Select the group user to be assigned");
        newErrors.option = "Select the group user to be assigned";
      }
    } else {
      if (!details?.role) {
        // toast.error("Select the Classify");
        newErrors.role = "Select the Classify";
      } else if (!details.message) {
        // toast.error("Enter the message");
        newErrors.message = "Enter the message";
      }
    }

    setErr(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      let payload = new FormData();
      payload.append("type", details?.role);
      payload.append("site_alert_notification_id", newList?.id);

      if (details.role == 4) {
        payload.append("assigned_user_id", option?.value);
      } else {
        payload.append("message", details?.message);
      }

      post(URL.NOTIFICATION_STATUS_UPDATE, payload)
        .then((res) => {
          if (res?.status == "success") {
            toast.success(res?.message);
            if (details.role == 4) {
              // setAssigned({
              //   status: details.role,
              //   assigned: option?.label || null,
              // });
              navigate("/group-allcoted");
            } else {
              // setMessage({
              //   status: details.role,
              //   message: details.message,
              // });
              navigate("/group-closed");
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const handleReopen = () => {
    let newErrors = {};
    if (details.reOpen == "") {
      newErrors.reOpen = "Selection is required";
    }
    setErr(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setShow(true);
    }
  };

  const handleClose = () => {
    let newErrors = {};
    if (details.reason == "") {
      newErrors.reason = "Reason is required";
    }
    setErr(newErrors);
    if (Object.keys(newErrors).length == 0) {
      let payload = new FormData();
      payload.append("type", 3);
      payload.append("site_alert_notification_id", newList?.id);
      payload.append("message", details.reason);
      post(URL.NOTIFICATION_STATUS_UPDATE, payload)
        .then((res) => {
          if (res?.status == "success") {
            toast.success(res?.message);
            navigate("/group-new");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const handleReassign = () => {
    let newErrors = {};

    if (details.reassign == "") {
      newErrors.reassign = "Select Alert";
    }

    if (details.reassign == 2) {
      if (!option?.label) {
        newErrors.option = "Select the group user to be Re-assign";
      }
      if (details.reassignMessage == "") {
        newErrors.reassignMessage = "Enter the reassign message";
      }
    }
    setErr(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const groupUserListApi = () => {
    post(URL.GROUP_USERS_ACTIVE_LIST, {})
      .then((res) => {
        let temp = [];
        res?.data?.map((item, ind) => {
          temp.push({
            ...item,
            old_name: item?.name,
            name: `${item?.name} - ${item?.phone}`,
          });
        });
        setList(temp);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getNotification = () => {
    let formdata = new FormData();
    post(URL.USER_NOTIFICATION_VIEW + data?.id, formdata)
      .then((res) => {
        if (res?.status == "success") {
          let data = res?.data;
          let obi = {
            Company: data?.company_name,
            SiteName: data?.site_name,
            SiteCode: data?.site_code,
            Type: data?.alert_type,
            ViolationType: data?.missed_item
              ? data?.missed_item
              : data?.alert_type,
            Camera: data?.camera_name,
            SeverityLevel: data?.severity,
            CapturedAt: data?.captured_at
              ? moment(data?.captured_at).format("DD-MM-YYYY, hh:mm A")
              : "-",
            ReceivedAt: data?.captured_at
              ? moment(data?.captured_at).format("DD-MM-YYYY, hh:mm A")
              : "-",
            Group2EscalatedAt: "",
            Group3EscalatedAt: "",
          };
          setAlertDetails(obi);
          let data_obi = {
            ...res?.data,
          };
          if (res?.data?.user_detail?.classified?.classified_at) {
            let deliverDate = res?.data?.user_detail?.classified?.classified_at;
            // let deliverDate = "06-11-2025, 12:06 PM";

            // Add 24 hours to get the expiry date
            let expiryDate = moment(deliverDate, "DD-MM-YYYY, h:mm A").add(
              24,
              "hours",
            );

            // Current date and time
            let currentDate = moment();

            // Compare
            if (currentDate.isAfter(expiryDate)) {
              // console.log("⚠️ Current time has surpassed the 24-hour limit.");
              data_obi.closed_status = 1;
            } else {
              data_obi.closed_status = 0;
              // console.log("✅ Still within 24 hours of delivery.");
            }
          }
          setNewList(data_obi);

          let classified = data?.user_detail?.classified;
          let assigned = data?.user_detail?.assigned;
          let reassigns = data?.user_detail?.reassigns;
          let classified_reopened = data?.user_detail?.classified_reopened;
          let reopens = data?.user_detail?.reopens;
          let closed = data?.user_detail?.closed;

          let classified_obi = {
            Classified:
              classified?.classified_status == 1
                ? "New"
                : classified?.classified_status == 2
                  ? "Invalid"
                  : classified?.classified_status == 3
                    ? "Compliant"
                    : classified?.classified_status == 4
                      ? "Non - Compliant"
                      : "",
            ClassifiedBy: classified?.classified_by ?? "",
            ClassifiedAt: classified?.classified_at
              ? // ? moment(classified?.classified_at).format("DD-MM-YYYY, hh:mm A")
                classified?.classified_at
              : "",
            AssignedTo: assigned?.assigned_to ?? "",
            ActAt: assigned?.assigned_at
              ? // ? moment(assigned?.assigned_at).format("DD-MM-YYYY, hh:mm A")
                assigned?.assigned_at
              : "",
          };
          setClassifiedData(classified_obi);
          let reassigned_ = [];
          if (reassigns?.length > 0) {
            reassigns?.map((item, ind) => {
              let obi = {
                Re_AssignedTo: item?.reassigned_to,
                Re_AssignedAt: item?.reassigned_at
                  ? // ? moment(item?.reassigned_at).format("DD-MM-YYYY, hh:mm A")
                    item?.reassigned_at
                  : "",
                Re_AssignedMessage: item?.reassigned_message,
                ClosedAt: "",
                ClosedMessage: "",
              };

              if (reassigns?.length - 1 == ind) {
                obi.ClosedAt = closed?.closed_at
                  ? // ? moment(closed?.closed_at).format("DD-MM-YYYY, hh:mm A")
                    closed?.closed_at
                  : "";

                obi.ClosedMessage = closed?.closed_message
                  ? closed?.closed_message
                  : "";
              }
              reassigned_.push(obi);
            });
          } else {
            if (closed?.closed_id) {
              reassigned_.push({
                Re_AssignedTo: "-",
                Re_AssignedAt: "-",
                Re_AssignedMessage: "-",
                ClosedAt: closed?.closed_at
                  ? // ? moment(closed?.closed_at).format("DD-MM-YYYY, hh:mm A")
                    closed?.closed_at
                  : "",
                ClosedMessage: closed?.closed_message
                  ? closed?.closed_message
                  : "",
              });
            } else {
              // reassigned_.push({
              //   Re_AssignedTo: "",
              //   Re_AssignedAt: "",
              //   Re_AssignedMessage: "",
              //   ClosedAt: "-",
              //   ClosedMessage: "-",
              // });
            }
          }

          setReassignedData(reassigned_);
          let reopens_ = [];

          classified_reopened?.map((item, ind) => {
            let obi = {};
            let reopen_ = reopens?.[ind];
            if (reopens?.[ind]) {
              obi.closed = {
                Closed_By: item?.classified_reopened_by,
                Closed_At: item?.classified_reopened_at,
                Closed_Message: item?.classified_reopened_message,
              };
              obi.reopend = {
                Reopen_By: reopen_?.reopened_by,
                Reopen_At: reopen_?.reopened_at,
                Reopen_Message: reopen_?.reopened_message,
              };
            } else {
              obi.closed = {
                Closed_By: item?.classified_reopened_by,
                Closed_At: item?.classified_reopened_at,
                Closed_Message: item?.classified_reopened_message,
              };
              obi.reopend = {};
            }
            reopens_.push(obi);
          });

          setReOpnedData(reopens_);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const assingedUserStatus = (payload, type) => {
    post(URL.ASSIGNED_USER_STATUS_UPDATE, payload)
      .then((res) => {
        if (res?.status == "success") {
          if (type == 3) {
            navigate("/group-closed");
          } else if (details?.reassign == 2) {
            navigate("/group-allcoted");
          } else {
            getNotification();
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const acceptandReassign = () => {
    if (handleReassign()) {
      let payload = new FormData();
      payload.append("type", details?.reassign);
      payload.append("site_alert_notification_id", newList?.id);

      if (details?.reassign == 2) {
        payload.append("re_assigned_user_id", option?.value);
        payload.append("message", details?.reassignMessage);
      }
      assingedUserStatus(payload);
    }
  };

  const closeAlert = (type) => {
    if (details.reassignMessage?.length == 0) {
      setErr((pre) => ({
        ...pre,
        ["reassignMessage"]: "Enter the reassign message",
      }));
    } else {
      let payload = new FormData();
      payload.append("type", type);
      payload.append("site_alert_notification_id", newList?.id);
      payload.append("message", details?.reassignMessage);
      assingedUserStatus(payload, type);
    }
  };

  //logs

  // console.log('details', details)
  // console.log('users', user)
  // console.log('assignedTo', assignedTo)
  // console.log('messageTo', messageTo)
  // console.log('err', err)

  useEffect(() => {
    if (data?.id) {
      getNotification();
    }
    groupUserListApi();
  }, []);

  // NOTIFICATION_STATUS_UPDATE

  return (
    <div className="dashRightView">
      <StatusComp
        name={`${type?.charAt(0)?.toUpperCase()}${type?.slice(1)} Details`}
      />

      <div className="Oversall-boxs p-4">
        {type == "new" ? (
          <>
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-3 primary text-start">
              Classify Alert
            </p>

            <div className="d-flex ac-jb mb-3">
              <div className="col-md-5">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                  Classify
                </p>
                <select
                  name="role"
                  className="input-box"
                  value={details.role}
                  onChange={handleChange}
                >
                  <option value={""} disabled>
                    New Alert
                  </option>
                  <option value={1}>Invalid</option>
                  <option value={2}>complaint</option>
                  <option value={4}>Non-complaint</option>
                </select>
                {err.role && <p className="err text-start mt-2">{err.role}</p>}
              </div>

              {details.role == 1 || details.role == 2 ? (
                <div className="col-md-6">
                  <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                    Message
                  </p>
                  <textarea
                    className="input-box"
                    name="message"
                    value={details.message}
                    onChange={handleChange}
                    placeholder="Enter Message"
                  ></textarea>
                  {err.message && (
                    <p className="err text-start mt-2">{err.message}</p>
                  )}
                </div>
              ) : details.role == 4 ? (
                <div className="col-md-6">
                  <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                    Assign
                  </p>
                  <SelectBox
                    arrayData={list}
                    selectedOption={option}
                    setSelectedOption={setOption}
                    style={true}
                    width={"400px"}
                    setErr={setErr}
                  />
                  {err.option && (
                    <p className="err text-start mt-2">{err.option}</p>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>

            {givenuser?.knf_type == 3 && (
              <div className="d-flex ac-js">
                <button
                  className="submit-btn"
                  style={{ minWidth: "130px" }}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            )}
          </>
        ) : type == "closed" ? (
          <>
            {newList?.user_detail?.closed?.closed_id ? (
              <div className="col-md-5">
                <p className="f2 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-18 fs-xxl-20 mb-1 text-start">
                  Closed
                </p>
              </div>
            ) : (
              <div className="col-md-5">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                  Alert
                </p>
                <select
                  name="reOpen"
                  className="input-box"
                  onChange={handleChange}
                >
                  <option value={""}>select</option>
                  <option value={3}>Reopen</option>
                </select>
                {err.reOpen && (
                  <p className="err text-start mt-2">{err.reOpen}</p>
                )}
                {givenuser?.knf_type == 3 && (
                  <div className="d-flex ac-js mt-4">
                    {/* {newList?.closed_status == 0 && ( */}
                    {/* {newList?.user_detail?.reassigns?.length > 2 || newList?.user_detail?.closed?.closed_id  ? ( */}

                    <button
                      className="submit-btn"
                      style={{ minWidth: "130px" }}
                      onClick={handleReopen}
                    >
                      Submit
                    </button>
                  </div>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            <div className="d-flex ac-jb">
              <div className="col-md-5">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                  Alert
                </p>
                {newList?.status == 6 ? (
                  <input className="input-box" value={"Accepted"} readOnly />
                ) : (
                  <select
                    name="reassign"
                    className="input-box"
                    onChange={handleChange}
                    value={details.reassign}
                  >
                    <option value={""} disabled>
                      Select
                    </option>
                    <option value={1}>Accepted</option>
                    <option
                      value={2}
                      disabled={newList?.user_detail?.reassigns?.length >= 2}
                    >
                      Re-Assign
                    </option>
                  </select>
                )}
                {err.reassign && (
                  <p className="err text-start mt-2">{err.reassign}</p>
                )}
              </div>
              {details.reassign == 2 && (
                <div className="col-md-6">
                  <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                    Re-Assign
                  </p>
                  <SelectBox
                    arrayData={list}
                    selectedOption={option}
                    setSelectedOption={setOption}
                    style={true}
                    width={"400px"}
                    setErr={setErr}
                  />
                  {err.option && (
                    <p className="err text-start mt-2">{err.option}</p>
                  )}
                </div>
              )}
            </div>

            {details.reassign == 2 && (
              <div className="col-md-5 mt-3">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                  Re-Assign Message
                </p>
                <textarea
                  className="input-box"
                  name="reassignMessage"
                  value={details.reassignMessage}
                  onChange={handleChange}
                  placeholder="Enter Message"
                ></textarea>
                {err.reassignMessage && (
                  <p className="err text-start">{err.reassignMessage}</p>
                )}
              </div>
            )}

            {newList?.status == 6 && (
              <div className="col-md-5 mt-3">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 text-start">
                  Closing Message
                </p>
                <textarea
                  className="input-box"
                  name="reassignMessage"
                  value={details.reassignMessage}
                  onChange={handleChange}
                  placeholder="Enter Message"
                ></textarea>
                {err.reassignMessage && (
                  <p className="err text-start">{err.reassignMessage}</p>
                )}
              </div>
            )}

            <div className="d-flex ac-js mt-4">
              {newList?.status == 6 ? (
                <button
                  className="submit-btn"
                  style={{ minWidth: "130px" }}
                  onClick={() => closeAlert(3)}
                >
                  Close
                </button>
              ) : newList?.user_detail?.reassigns?.[
                  newList?.user_detail?.reassigns?.length - 1
                ]?.reassigned_id == givenuser?.id ? (
                <button
                  className="submit-btn"
                  style={{ minWidth: "130px" }}
                  onClick={acceptandReassign}
                >
                  Submit
                </button>
              ) : newList?.user_detail?.assigned?.assigned_id ==
                  givenuser?.id &&
                newList?.user_detail?.reassigns?.length == 0 ? (
                <button
                  className="submit-btn"
                  style={{ minWidth: "130px" }}
                  onClick={acceptandReassign}
                >
                  Submit
                </button>
              ) : null}
            </div>
          </>
        )}
      </div>

      <div className="row gap-5 mb-3">
        <div className="Oversall-boxs" style={{ width: "50%" }}>
          <img
            role="button"
            onClick={() =>
              setShowPopup(newList?.alert_image ? newList?.alert_image : "")
            }
            src={newList?.alert_image ? newList?.alert_image : ""}
            className="construction"
          />
        </div>

        <div className="Oversall-boxs" style={{ width: "45%" }}>
          {Object.entries(alertDetails).map(([key, value]) => {
            return (
              <div key={key} className="d-flex ac-jb my-3 mx-5">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1">
                  {formatKey(key)}
                </p>
                <input className="input-box w-50" value={value} readOnly />
              </div>
            );
          })}
        </div>
      </div>

      <div className="row gap-5 mb-3">
        <div className="Oversall-boxs" style={{ width: "45%" }}>
          {Object.entries(classifiedData).map(([key, value]) => {
            return (
              <div key={key} className="d-flex ac-jb my-3 mx-5">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1">
                  {formatKey(key)}
                </p>
                <input className="input-box w-50" value={value} readOnly />
              </div>
            );
          })}
        </div>
        {reassignedData?.map((item, ind) => {
          return (
            <div className="Oversall-boxs" style={{ width: "45%" }} key={ind}>
              {Object.entries(item).map(([key, value]) => {
                return (
                  <div key={key} className="d-flex ac-jb my-3 mx-5">
                    <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1">
                      {formatKey(key)}
                    </p>
                    {key.includes("Message") ? (
                      <textarea
                        className="input-box w-50"
                        value={value}
                        readOnly
                      ></textarea>
                    ) : (
                      <input
                        className="input-box w-50"
                        value={value}
                        readOnly
                      />
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* <div className="row gap-5 mb-3">
        <div className="Oversall-boxs" style={{ width: "45%" }}>
          {Object.entries(classifiedData).map(([key, value]) => {
            return (
              <div key={key} className="d-flex ac-jb my-3 mx-5">
                <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1">
                  {formatKey(key)}
                </p>
                <input className="input-box w-50" value={value} readOnly />
              </div>
            );
          })}
        </div> */}
      <div className="w-100">
        {reOpnedData?.map((item, ind) => {
          return (
            <div className="row gap-5 mb-3">
              {Object.values(item?.closed)?.length > 0 && (
                <div
                  className="Oversall-boxs"
                  style={{ width: "45%" }}
                  key={ind}
                >
                  {Object.entries(item?.closed).map(([key, value]) => {
                    return (
                      <div key={key} className="d-flex ac-jb my-3 mx-5">
                        <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1">
                          {formatKey(key)}
                        </p>
                        {key.includes("Message") ? (
                          <textarea
                            className="input-box w-50"
                            value={value}
                            readOnly
                          ></textarea>
                        ) : (
                          <input
                            className="input-box w-50"
                            value={value}
                            readOnly
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
              {Object.values(item?.reopend)?.length > 0 && (
                <div
                  className="Oversall-boxs"
                  style={{ width: "45%" }}
                  key={ind}
                >
                  {Object.entries(item?.reopend).map(([key, value]) => {
                    return (
                      <div key={key} className="d-flex ac-jb my-3 mx-5">
                        <p className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1">
                          {formatKey(key)}
                        </p>
                        {key.includes("Message") ? (
                          <textarea
                            className="input-box w-50"
                            value={value}
                            readOnly
                          ></textarea>
                        ) : (
                          <input
                            className="input-box w-50"
                            value={value}
                            readOnly
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <Modal
        show={showPopup}
        onHide={() => setShowPopup(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <div className="p-3">
          <img
            src={showPopup}
            className="rounded "
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
        <div className="d-flex ac-jc mt-3 mb-3">
          <button onClick={() => setShowPopup(false)} className="submit-btn">
            Close
          </button>
        </div>
      </Modal>

      {show && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h5 className="f3 mt-4">Enter Reason</h5>
            <textarea
              value={details.reason}
              placeholder="Reason"
              onChange={handleChange}
              className="input-box mt-2"
              name="reason"
            />
            {err.reason && <p className="err my-2">{err.reason}</p>}
            <div className="d-flex ac-jb px-2 mt-2">
              <button onClick={() => setShow(false)} className="back-btn w-40">
                Cancel
              </button>
              <button onClick={handleClose} className="add-btn f2 w-40">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OverallAlertdetails;
